import { Space, Form, Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'

function ServiceDetailsActionForm(): JSX.Element {
  return (
    <Form
      name="coreservicedetails"
      labelAlign="left"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 12 }}
      className="core-servicedetails-form"
    >
      <Space direction="vertical" size={16}>
        <div>
          Remove this service’s data if administrator requested that, if not please be aware that what has been deleted
          can never brough back
        </div>

        <Form.Item>
          <Button type="primary" danger icon={<DeleteOutlined />}>
            DELETE SERVICE
          </Button>
        </Form.Item>
      </Space>
    </Form>
  )
}

export default ServiceDetailsActionForm
